// This file contains only the client (=sunrise) relevant interfaces. Not the ones provided by the -service itself.
export var Partner;
(function (Partner) {
    Partner[Partner["UBERALL"] = 0] = "UBERALL";
    Partner[Partner["YEXT"] = 1] = "YEXT";
})(Partner || (Partner = {}));
//# sourceMappingURL=branchenbuch.js.map